import { SxProps, Theme } from '@mui/material';

export const cardSx: SxProps<Theme> = {
  mb: 2,
  backgroundColor: '#1a1a1a',
  border: '1px solid #333'
};

export const sectionHeaderSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '#464545',
  color: 'white',
  p: 2,
  borderRadius: '8px 8px 0 0'
};

export const headerLeftSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1
};

export const addButtonSx: SxProps<Theme> = {
  color: 'white',
  borderColor: 'white',
  '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
};

export const cardContentSx: SxProps<Theme> = {
  backgroundColor: '#161616',
  color: 'white'
};

export const loadingBoxSx: SxProps<Theme> = {
  textAlign: 'center',
  py: 4
};

export const emptyTextSx: SxProps<Theme> = {
  py: 4,
  textAlign: 'center'
};

export const addressesWrapSx: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 2
};

export const addressBoxSx: SxProps<Theme> = {
  flexBasis: { xs: '100%', md: 'calc(50% - 8px)' },
  minWidth: 0
};

export const addressCardSx: SxProps<Theme> = {
  backgroundColor: '#2a2a2a',
  border: '1px solid #555'
};

export const addressCardContentSx: SxProps<Theme> = {};

export const addressCardTopSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  mb: 2
};

export const addressTypeChipSx: SxProps<Theme> = {};

export const addressActionsSx: SxProps<Theme> = {
  display: 'flex',
  gap: 1
};

export const iconButtonSx: SxProps<Theme> = {
  color: 'white'
};

export const addressFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': { 
    color: 'white',
    '& fieldset': { borderColor: '#666' },
    '&:hover fieldset': { borderColor: '#999' },
    '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
    },
    '& .MuiInputLabel-root': { color: '#999' }
};

export const dialogTitleSx: SxProps<Theme> = {
  backgroundColor: '#2a2a2a',
  color: 'white'
};

export const dialogContentSx: SxProps<Theme> = {
  backgroundColor: '#2a2a2a',
  color: 'white'
};

export const dialogActionsSx: SxProps<Theme> = {
  backgroundColor: '#2a2a2a'
};

export const selectFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    color: 'white',
    '& fieldset': { borderColor: '#666' },
    '&:hover fieldset': { borderColor: '#999' },
    '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
  },
  '& .MuiInputLabel-root': { color: '#999' },
  '& .MuiSvgIcon-root': { color: 'white' }
};

export const selectMenuPaperSx: SxProps<Theme> = {
  backgroundColor: '#2a2a2a',
  '& .MuiMenuItem-root': {
    color: 'white',
    '&:hover': { backgroundColor: '#3a3a3a' }
  }
};

export const textFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    color: 'white',
    '& fieldset': { borderColor: '#666' },
    '&:hover fieldset': { borderColor: '#999' },
    '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
  },
  '& .MuiInputLabel-root': { color: '#999' }
};

export const addressHelperTextSx: SxProps<Theme> = {
  mt: 1,
  color: 'text.secondary'
};